import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/PageHeader";
import { resubmitMyEventOrganizer } from "@/api/organiser-desk";

/**
 * Send the page to the check again after a no or a request for more. The
 * server refuses while a request waits (VERIFICATION_PENDING) and once the
 * page is checked (ALREADY_VERIFIED); the refusal is shown as it comes.
 */
export function ResubmitPanel() {
  const qc = useQueryClient();
  const [note, setNote] = useState("");
  const [msg, setMsg] = useState<string | null>(null);

  async function send() {
    setMsg(null);
    try {
      const res = await resubmitMyEventOrganizer(note.trim() || undefined);
      setMsg(`Sent again: ${res.data.verificationRequest?.status ?? "no request"}`);
      setNote("");
      await qc.invalidateQueries({ queryKey: ["event-organizer-me"] });
    } catch (e) {
      setMsg(e instanceof Error ? e.message : "That did not work");
    }
  }

  return (
    <div className="flex gap-2 flex-wrap items-center mt-3">
      <input
        className="input w-96"
        placeholder="A note for the reviewer (optional, up to 1000)"
        maxLength={1000}
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
      <Button size="sm" onClick={() => void send()}>
        Send again
      </Button>
      {msg && <p className="text-xs text-gray-600">{msg}</p>}
    </div>
  );
}
